/**
 * `Contents` flow ID
 * @type {string}
 */
export const C_FLOW_ID = 'item_5994788bf965810034710f40159';

/**
 * `Private Liability` flow ID
 * @type {string}
 */
export const PL_FLOW_ID = 'item_5a3905dc363122c6e5c8474e212';

/**
 * `Buildings` flow ID
 * @type {string}
 */
export const B_FLOW_ID = 'item_584a39bbf525ae7e16872650e69';

/**
 * `Contents + Private Liability` flow ID
 * @type {string}
 */
export const C_PL_FLOW_ID = 'item_957711384345569b02c8ad7cc7a';

/**
 * `Contents + Buildings` flow ID
 * @type {string}
 */
export const C_B_FLOW_ID = 'item_5991be0f8150e87e8663b49d2ac';

/**
 * `Private Liability + Buildings` flow ID
 * @type {string}
 */
export const PL_B_FLOW_ID = 'item_18127b9f3c3ade0df4330aa9bd8';

/**
 * `Contents + Private Liability + Buildings` flow ID
 * @type {string}
 */
export const TRIPLE_FLOW_ID = 'item_7e644b3be4c54b18c53e7138511';
